import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IRiResearchOrganizationUnit } from '@/shared/model/ri-research-organization-unit.model';

const baseApiUrl = 'api/ri-research-organization-units';

export default class RiResearchOrganizationUnitService {
  public find(id: number): Promise<IRiResearchOrganizationUnit> {
    return new Promise<IRiResearchOrganizationUnit>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public search(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/search?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IRiResearchOrganizationUnit): Promise<IRiResearchOrganizationUnit> {
    return new Promise<IRiResearchOrganizationUnit>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IRiResearchOrganizationUnit): Promise<IRiResearchOrganizationUnit> {
    return new Promise<IRiResearchOrganizationUnit>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public uploadLogoFile(file: File, riouId: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const formData = new FormData();
      formData.append('files', file);
      formData.append('riouId', riouId.toString());

      axios
        .post('api/ri-research-organization-units/upload-logo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => {
          // Response je direktno filename string
          resolve(res.data);
        })
        .catch(err => reject(err));
    });
  }

  public deleteLogoFile(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`api/ri-research-organization-units/delete-logo/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public retrieveLogoImage(filename: string): string {
    return `api/retrieve/image/${encodeURIComponent(filename)}`;
  }
}
